import React from "react";
import { useSite } from "../../context/site";
import { Eyebrow, Cta } from "../../components/site/kit";
import { Reveal } from "../../components/site/motion";
import { useHomeCopy } from "../../lib/siteContent";
import { RichCopy } from "../../components/site/RichCopy";

export const Closing = () => {
  const { openTalk } = useSite();
  const c = useHomeCopy();
  return (
  <section data-testid="home-closing" className="bg-[#161A15]">
    <div className="mx-auto grid max-w-[1360px] items-center gap-14 px-6 py-24 md:px-12 md:py-32 lg:grid-cols-12 lg:px-16">
      <Reveal className="lg:col-span-7">
        <Eyebrow dark>{c.closingEyebrow}</Eyebrow>
        <h2 className="font-display mt-6 text-5xl leading-[0.95] tracking-tight text-white md:text-6xl lg:text-7xl">
          <RichCopy text={c.closingHeading} />
        </h2>
        <p className="font-body mt-8 max-w-lg text-xl font-normal leading-relaxed text-white/90">
          {c.closingSubhead}
        </p>
      </Reveal>
      <div className="flex flex-col gap-5 lg:col-span-5 lg:justify-center">
        <Cta primary onClick={() => openTalk()} testId="home-closing-cta" className="w-full justify-between">{c.closingCta1}</Cta>
        <Cta dark to="/find-your-switch" testId="home-closing-cta-2" className="w-full justify-between">{c.closingCta2}</Cta>
      </div>
    </div>
  </section>
  );
};

